import { dcaBaseUrl } from './dca'
import { Edcm } from '@komi-app/edcm-sdk'

export const embedUrl = `${dcaBaseUrl}/embed`

export const defaultEdcm: Omit<Edcm, 'id'> = {
  title: '',
  description: '',
  successMessage: '',
  talentProfileId: '',
  dataCaptureMethods: [
    {
      name: 'email',
      label: 'Email',
      isVisible: true
    },
    {
      name: 'phoneNumber',
      label: 'Phone Number',
      isVisible: true
    }
  ],
  additionalCaptureMethods: [
    {
      name: 'name',
      label: 'Full Name',
      isVisible: true,
      isRequired: false
    },
    {
      name: 'country',
      label: 'Country',
      isVisible: true,
      isRequired: false
    },
    {
      name: 'dob',
      label: 'Date of birth',
      isVisible: true,
      isRequired: false
    }
  ],
  textAndIconColor: '#000000',
  backgroundColor: '#FFFFFF',
  buttonTextColor: '#FFFFFF',
  buttonBackgroundColor: '#0F69E6',
  font: 'Roboto',
  borderRadius: 8
}
